import { paths } from '@app/paths';
import { Navigate } from 'react-router-dom';

export const RedirectOrderSheet = () => <Navigate to={paths.SELECTIONS} replace />;
